'use client';

import type {
  ProgramPortfolio,
  ProgramDetails,
} from '@/modules/Entertainment/interface/Program';
import type { FC } from 'react';
import { Flex, Text, Accordion, Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { RecommendedWalletItem } from './RecommendedWalletItem';

export const RecommendedWallets: FC<RecommendedWalletsProps> = ({
  programTitle,
  wallets,
  isLoading,
}) => {
  const t = useT();

  if (isLoading) {
    return (
      <Flex flexDir="column" gap="l">
        <Skeleton w="18.75rem" h="1.25rem" borderRadius="0.1875rem" />
        <Flex flexDir="column" gap="l">
          <Skeleton w="full" h="21.875rem" borderRadius="0.1875rem" />
        </Flex>
      </Flex>
    );
  }

  if (!wallets.length) {
    return <></>;
  }

  return (
    <Flex
      id="carteiras"
      flexDir="column"
      gap="l"
      sx={{ '& #eqiDSTable': { p: 0 } }}
    >
      <Text
        size="h6"
        fontWeight="normal"
      >{`${t('attributes.wallets')} do ${programTitle}`}</Text>
      <Accordion
        defaultIndex={[0]}
        allowMultiple
        display="flex"
        flexDir="column"
        gap="l"
      >
        {wallets.map(({ id, title, assets }) => (
          <RecommendedWalletItem key={id} title={title} assets={assets} />
        ))}
      </Accordion>
    </Flex>
  );
};

type RecommendedWalletsProps = {
  wallets: ProgramPortfolio[];
  programTitle: ProgramDetails['title'];
  isLoading?: boolean;
};
